import cx from 'classnames';
import TripCard from "./TripCard";

export default function TipCardList({ trips, editable = false, isLoading= false, business = false}) {
    return (
        <ul className={cx("grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3", {
            "sm:grid-cols-2": business
        })}>
            {trips.map((trip, index) => (
                <li key={index}>
                    <TripCard business={business} trip={trip} editable={editable} isLoading={isLoading} />
                </li>
            ))}
        </ul>
    );
}
